/**
 * Query key factory for pot periods
 * Following the pattern from userKeys.ts
 */

import type { GetPotPeriodsOptions } from '../api/potPeriodsApi';

export const potPeriodKeys = {
  all: ['pot-periods'] as const,
  lists: () => [...potPeriodKeys.all, 'list'] as const,
  list: (options?: GetPotPeriodsOptions) =>
    [...potPeriodKeys.lists(), options ?? {}] as const,
};
